import { useGT } from 'gt-react';
import { ArrowSquareOutIcon } from '@phosphor-icons/react';
import { Link } from '@tanstack/react-router';
import { Button } from 'src/components/ui/button';

export function OpenFullTaskButton({ taskId }: { taskId: string }) {
  const gt = useGT();
  return (
    <Button
      variant="ghost"
      size="icon"
      asChild
      className="h-6 w-6"
      aria-label={gt('Open full task view', {
        context: 'button to open the full task page from agent monitor',
      })}
      title={gt('Open full task view', {
        context: 'tooltip for opening the full task page from agent monitor',
      })}
    >
      <Link to="/tasks/$taskId" params={{ taskId }}>
        <ArrowSquareOutIcon className="size-3.5" />
      </Link>
    </Button>
  );
}
